export const LC_UPDATE_LIST = 'LC_UPDATE_LIST'
export const LC_UPDATE_LIST_METHOD = 'LC_UPDATE_LIST_METHOD'
export const LC_UPDATE_FORM = 'LC_UPDATE_FORM'
export const LC_UPDATE_FORM_FIELD = 'LC_UPDATE_FORM_FIELD'
export const LC_UPDATE_PREVIEW = 'LC_UPDATE_PREVIEW'

export const updateLearningContinuumList = (curriculumId, { data, count }) => ({
  type: LC_UPDATE_LIST,
  payload: { curriculumId, data, count }
})
export const updateLearningContinuumListMethod = (curriculumId, method, data) => ({
  type: LC_UPDATE_LIST_METHOD,
  payload: { curriculumId, method, data }
})
export const updateLearningContinuumForm = (data) => ({
  type: LC_UPDATE_FORM,
  payload: data
})
export const updateLearningContinuumFormField = (field, value) => ({
  type: LC_UPDATE_FORM_FIELD,
  payload: { field, value }
})
export const updateLearningContinuaPreview = (preview = null) => ({
  type: LC_UPDATE_PREVIEW,
  payload: preview
})